import OnboardingEventsAndConversions from "features/onboarding/components/OnboardingEventsAndConversions";

interface IEcomPlatformOnboardingStep4Props {
  onContinue: () => void;
}

function EcomPlatformOnboardingStep4({
  onContinue,
}: IEcomPlatformOnboardingStep4Props) {
  return <OnboardingEventsAndConversions onContinue={onContinue} />;
}

export default EcomPlatformOnboardingStep4;
